import { render } from "./page14.vue?vue&type=template&id=a171bf6a&scoped=true"
import script from "./page14.vue?vue&type=script&lang=js"
export * from "./page14.vue?vue&type=script&lang=js"

import "./page14.vue?vue&type=style&index=0&id=a171bf6a&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a171bf6a"]])

export default __exports__